import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import VueRouter from 'vue-router'
import Routes from './routes'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(VueRouter)

Vue.prototype.$axios = axios
Vue.prototype.$payStackPK = process.env.VUE_APP_PAYSTACK_PUBLIC_KEY
Vue.prototype.$charge = Math.abs(process.env.VUE_APP_ACCESS_FEE)
Vue.prototype.$baseUrl = ""

const router = new VueRouter({
  routes: Routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
      // return { x: 0, y: 0 }
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {

	if (store.state.loginDialog) {
    store.state.loginDialog = false
    next('false')
  } else if (store.state.registerDialog) {
    store.state.registerDialog = false
    next(false)
  } else if (store.state.howItWorks) {
    store.state.howItWorks = false
    next(false)
  } else if (store.state.movageDialog) {
    store.state.movageDialog = false
    next(false)
  } else if (store.state.aboutDialog) {
    store.state.aboutDialog = false
    next(false)
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      if (localStorage.uid === undefined) {
        // Output a feedback message to the user and redirects user to home page!
        store.dispatch('setSnackText', "Requested page is restricted to only registered user! Login into your account to continue...")

        // Prompts User To login
        store.state.loginDialog = true

        next(false)
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }
  }
})

new Vue({
  store,
  render: h => h(App),
  router: router
}).$mount('#app')
